import { byId } from "../utils";

// const root = byId("indexTemplate")

export default function index(app) {
	app.router.on((match) => {
		app.router.navigate('/missions')
	})
}